const DESKTOP_WIDTH_THRESHOLD = 991;

export default class HamburgerView {
  _hamburgerButton = document.querySelector(".menu-button.w-nav-button");
  _navOverlay = document.getElementById("w-nav-overlay-0");

  toggleMenu() {
    // Toggle menu and overlay styles on button click
    this._hamburgerButton.onclick = (e) => {
      e.stopPropagation();

      // Exit if screen is wider than 991px
      if (window.innerWidth > DESKTOP_WIDTH_THRESHOLD) {
        return;
      }

      const isOpen = this._hamburgerButton.classList.toggle("w--open");

      if (isOpen) {
        // Apply overlay styles when opening
        this._navOverlay.style.display = "block";
        this._navOverlay.style.height = "2691.45px";
      } else {
        // Reset styles when closing
        this._navOverlay.style.display = "none";
        this._navOverlay.style.height = "";
      }
    };

    // Close menu when clicking outside
    document.onclick = (e) => {
      if (
        !e.target.closest(".menu-button") &&
        this._hamburgerButton.classList.contains("w--open")
      ) {
        this._hamburgerButton.classList.remove("w--open");
        this._navOverlay.style.display = "none";
        this._navOverlay.style.height = "";
      }
    };

    // Handle window resize to close menu and hide overlay on desktop
    window.addEventListener("resize", () => {
      if (window.innerWidth > DESKTOP_WIDTH_THRESHOLD) {
        this._hamburgerButton.classList.remove("w--open");
        this._navOverlay.style.display = "none";
        this._navOverlay.style.height = "";
      }
    });
  }
}
